import {
    LOGIN_REQUEST,
    LOGIN_SUCCESS,
    LOGIN_FAIL,
    PASSWORD_CHANGE_REQUEST,
    PASSWORD_CHANGE_SUCCESS,
    PASSWORD_CHANGE_FAIL
} from '../constants/Users';

const initialState = {
    submitted: false,
    isHandlingSubmission: false,
    successfulSubmission: false,
};

export default function formStatus(state = initialState, action) {
    switch (action.type) {
        case 'RESET_FORM':
            return initialState;
        case LOGIN_REQUEST:
            return {
                ...state,
                submitted: true,
                isHandlingSubmission: true
            };
        case LOGIN_SUCCESS:
            return {
                ...state,
                isHandlingSubmission: false,
                successfulSubmission: true
            };
        case LOGIN_FAIL:
            return {
                ...state,
                isHandlingSubmission: false,
                successfulSubmission: false
            };
        case PASSWORD_CHANGE_REQUEST:
            return {
                ...state,
                submitted: true,
                isHandlingSubmission: true
            };
        case PASSWORD_CHANGE_SUCCESS:
            return {
                ...state,
                isHandlingSubmission: false,
                successfulSubmission: true
            };
        case PASSWORD_CHANGE_FAIL:
            return {
                ...state,
                isHandlingSubmission: false,
                successfulSubmission: false
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/formStatus.js